class MatrizService {
  constructor() {}
  resources = () => ({
    listarOpexCampo: {
      uri: `/v1/presupuesto/opex/listar-header-opex-campo`,
      method: ['get']
    },
    listarOpexTI: {
      uri: `/v1/presupuesto/opex/listar-header-opex-ti`,
      method: ['get']
    },
    exportarOpexCampo: {
      uri: `/v1/presupuesto/exportar-versiones`,
      method: ['get']
    },
    exportarOpexTI: {
      uri: `/v1/presupuesto/exportar-versiones-ti`,
      method: ['get']
    },
    exportarGeneralOpex: {
      uri: `/v1/presupuesto/exportar-total-opex`,
      method: ['get']
    },
    exportarGeneralOpexTI: {
      uri: `/v1/exportar-opexti-total`,
      method: ['get']
    },
    cambiarEstado: {
      uri: `/v1/presupuesto/opex/cambio-estado`,
      method: ['post'],
      headers: { 'Content-Type': 'application/json' }
    },
    eliminar: {
      uri: `/v1/presupuesto/eliminacion-logica`,
      method: ['post'],
      headers: { 'Content-Type': 'application/json' }
    },
    permisos: {
      uri: `/v1/usuario/permisos`,
      method: ['get']
    },
    cargarAnios: {
      uri: `/v1/presupuesto/anios`,
      method: ['get']
    }
  });
}

export default MatrizService;
